module.exports = __webpack_public_path__ + "img/discussion.7d6d2897.png";